export const FETCH_QUESTIONS_PENDING = 'FETCH_QUESTIONS_PENDING';
export const FETCH_QUESTIONS_REJECTED = 'FETCH_QUESTIONS_REJECTED';
export const FETCH_QUESTIONS_FULFILLED = 'FETCH_QUESTIONS_FULFILLED';



// WEBPACK FOOTER //
// ./src/constants/calculateQuestions.js